// @flow
import * as React from 'react';
import styled, {keyframes} from 'styled-components';
import SpotIcon from './IconSpot';
import ImgPlus from 'assets/images/driving-zone/b/img-plugin-plus.svg';

type Props = {
  onClick: () => void,
  posX?: number,
  posY?: number,
  children?: React.Node,
  ignoreSafeArea?: bool
};

//TODO : Safe area 관련 옵셋 생기는 문제 전체적으로 점검
export const ButtonSpot : React.AbstractComponent<Props, any> = React.forwardRef<Props, any>(
  (props: Props, ref: any) =>  {

  const {onClick, posX, posY, ignoreSafeArea, children, ...others} = props;
  
  return (
    <GuidePointParent {...others} ref={ref}>
      <GuidePoint onClick={onClick}
        dataleft={posX}
        datatop={posY}
        ignoreSafeArea={ignoreSafeArea}
        >

        <SpotIcon />
        <img src={ImgPlus} alt="" />
        {children}
      </GuidePoint>
    </GuidePointParent>
  );
}
);

const circularProgress = keyframes`
  from {
    transform: rotate(-90deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const circularProgress4 = keyframes`
  from {
    transform: translate(0, -100%)
  }
  60% {
    transform: translate(0, 0)
  }
  to {
    transform: translate(0, 0)
  }
`;
const circularProgress5 = keyframes`
  from {
    transform: translate(0, 0)
  }
  60% {
    transform: translate(0, -100%)
  }
  to {
    transform: translate(0, -100%)
  }
`;
const circularProgress6 = keyframes`
  from {
    transform: translate(0, 100%)
  }
  25% {
    transform: translate(0, 100%)
  }
  to {
    transform: translate(0, 0%)
  }
`;
const fadeInOut = keyframes`
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
`;
const fadeIn: Keyframe = keyframes`
  from {
    opacity: 0;
  }
  95%{
    opacity: 1;
  }
  to {
    opacity: 1;
  }
`;
const GuidePointParent = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
`;

const GuidePoint = styled.button`
  width: ${(props) => (props.theme.layout.mobile ? 65 : 104)}px;
  height: ${(props) => (props.theme.layout.mobile ? 65 : 104)}px;
  left: calc(${(props) => (props.dataleft ?? 0) - (props.theme.layout.mobile ? 65 : 105) * 0.5}px -  ${(props) => (props.ignoreSafeArea ? "0px" : "env(safe-area-inset-left)")} );
  top: calc(${(props) => (props.datatop ?? 0) - (props.theme.layout.mobile ? 65 : 104) * 0.5}px - ${(props) => (props.ignoreSafeArea ? "0px" : "env(safe-area-inset-top)")} );
  position: absolute;
  transform: scale(${(props) => props.theme.layout.scale});
  transform-origin: center center;

  > svg {
    width: 100%;
    height: 100%;
    #mask001 {
      animation: ${circularProgress} 2s;
      transform-origin: center center;
    }
    #mask002 {
      animation: ${circularProgress4} 2s;
      transform-origin: center center;
    }
    #mask003 {
      animation: ${circularProgress6} 2s;
      transform-origin: center center;
    }
    #mask004 {
      animation: ${circularProgress5} 2s;
      transform-origin: center center;
    }

    animation: 2s ease-in-out 1.5s ${fadeInOut};
    animation-iteration-count: infinite;
  }

  > img {
    position: absolute;
    left: ${(props) => (props.theme.layout.mobile ? 22.5 : 36)}px;
    top: ${(props) => (props.theme.layout.mobile ? 22.5 : 36)}px;
    width: ${(props) => (props.theme.layout.mobile ? 20 : 32)}px;
    height: ${(props) => (props.theme.layout.mobile ? 20 : 32)}px;
    animation: 5s ease-in-out 0s ${fadeIn};
  }
`;

export default ButtonSpot;
export {fadeIn};